import React from "react";
import { BackendContext, BackendInterface } from "../..";

type Props = {
  children: React.ReactNode;
  backend: BackendInterface;
};

export const BackendProvider = (props: Props) => {
  return (
    <BackendContext.Provider value={props.backend}>
      {props.children}
    </BackendContext.Provider>
  );
};
